<template>
  <div class="misoftphone">
    <el-row
      type="flex"
      class="row-bg phonestatus"
      justify="space-around"
    >
      <el-col :span="6"></el-col>
      <el-col>分机号：{{ extno }}</el-col>
      <el-col>状态：{{ globalStatus.tips }}</el-col>
      <el-col>当前排队量：{{ waitnum }}</el-col>
      <el-col>当前接听量：{{ answernum }}</el-col>
      <el-col>异常记录：<div
          class="light"
          :style="{backgroundColor: globalStatus.statusColor}"
        ></div>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      class="row-bg"
      justify="space-around"
    >
      <el-col :span="6"></el-col>
      <el-col>
        <el-button
          ref="loadingLogin"
          type="primary"
          size="mini"
          :loading="loadingLogin"
          @click="login(globalStatus.text.login)"
          :disabled="globalStatus.button.login"
        >{{
          globalStatus.text.login
        }}</el-button>
      </el-col>
      <el-col>
        <el-button
          ref="loadingReady"
          type="primary"
          size="mini"
          :loading="loadingReady"
          :disabled="globalStatus.button.ready"
          @click="ready(globalStatus.text.ready)"
        >{{
          globalStatus.text.ready
        }}</el-button>
      </el-col>
      <el-col>
        <el-button
          ref="loadingHold"
          type="primary"
          size="mini"
          :loading="loadingHold"
          @click="hold(globalStatus.text.hold)"
          :disabled="globalStatus.button.hold"
        >{{
          globalStatus.text.hold
        }}</el-button>
      </el-col>
      <el-col>
        <el-button
          ref="loadingSurvey"
          type="primary"
          size="mini"
          :loading="loadingSurvey"
          @click="survey"
          :disabled="globalStatus.button.survey"
        >{{ globalStatus.text.survey }}</el-button>
      </el-col>
      <el-col>
        <el-button
          ref="loadingHungup"
          type="primary"
          size="mini"
          :loading="loadingHungup"
          @click="hangup"
          :disabled="globalStatus.button.hungup"
        >{{ globalStatus.text.hungup }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable */
import { xuanMiCall } from './record/pool'
import { RESPONSE_CODE } from '@public/http/config'
const TIMEOUT = 10000
export default {
  name: 'MiSoftphone',
  props: ['extno'],
  computed: {
    globalStatus: function () {
      let objec = {
        text: {},
        button: {},
        tips: {},
      }
      // 1未登录
      // 2已登陆
      // 3未就绪
      // 4已就绪
      // 5振铃中
      // 6通话中
      // 7保持中
      // 8处理中
      switch (this.softPhoneStatus) {
        case 1:
          objec = {
            text: {
              login: '登陆',
              ready: '未就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: true,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '未登录',
            statusColor: 'red'
          }
          break
        case 2:
          objec = {
            text: {
              login: '登出',
              ready: '未就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: false,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '已登陆',
            statusColor: 'chartreuse'
          }
          break
        case 3:
          objec = {
            text: {
              login: '登出',
              ready: '未就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: false,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '未就绪',
            statusColor: 'chartreuse'
          }
          break
        case 4:
          objec = {
            text: {
              login: '登出',
              ready: '就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: false,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '就绪中',
            statusColor: 'chartreuse'
          }
          break
        case 5:
          objec = {
            text: {
              login: '登出',
              ready: '就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: false,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '振铃中',
            statusColor: 'chartreuse'
          }
          break
        case 6:
          objec = {
            text: {
              login: '登出',
              ready: '就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: true,
              ready: true,
              hold: false,
              survey: false,
              hungup: false,
            },
            tips: '通话中',
            statusColor: 'chartreuse'
          }
          break

        case 7:
          objec = {
            text: {
              login: '登出',
              ready: '就绪',
              hold: '取回',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: true,
              ready: true,
              hold: false,
              survey: true,
              hungup: true,
            },
            tips: '保持中',
            statusColor: 'chartreuse'
          }
          break
        case 8:
          objec = {
            text: {
              login: '登出',
              ready: '就绪',
              hold: '保持',
              survey: '邀评',
              hungup: '挂断',
            },
            button: {
              login: false,
              ready: false,
              hold: true,
              survey: true,
              hungup: true,
            },
            tips: '处理中',
            statusColor: 'chartreuse'
          }
          break
      }
      return objec
    },
  },
  data() {
    return {
      flag: false,
      uuid: '',
      trackingnumber: '',
      phone: '',
      currenPhone: '',
      waitnum: '0',
      answernum: '0',
      softPhoneStatus: 1,
      loadingLogin: false,
      loadingHold: false,
      loadingReady: false,
      loadingSurvey: false,
      loadingHungup: false,
      opcall: null,
      uuidObj:{}
    }
  },
  watch: {
    trackingnumber(a) {
      if (a != '') {
        this.$emit('changeWaybill', a)
      }
      this.trackingnumber = ''
    },
    phone(a) {
      if (a != '') {
        this.$emit('changePhone', a)
      }
      this.phone = ''
    },
  },

  mounted() {
    //监听页面刷新触发事件
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    this.getQueryListen()
    this.$nextTick(() => {
      const list = ['loadingLogin', 'loadingHold', 'loadingHungup', 'loadingHold', 'loadingReady', 'loadingSurvey']
      list.forEach((item) => {
        this.$refs[item].$el.onkeydown = (e) => {
          let _key = window.event.keyCode
          if (_key === 13 || _key === 32) {
            return false
          }
        }
      })
    })
  },
  destroyed: function () {
    if (this.softPhoneStatus !== 1) {
      console.log('页面销毁==============');
      this.login('登出')
      // window.removeEventListener('beforeunload', e =>this.beforeunloadHandler(e))
    }
  },
  methods: {
    // beforeunloadHandler(e) {
    //   console.log('浏览器刷新==============');
    //   this.login('登出')
    // },
    // 失败
    error(message) {
      this.$message.error(message)
    },
    // 警告
    warning(message) {
      this.$message.warning(message)
    },
    // 成功
    success(message) {
      this.$message.success(message)
    },
    // 接听
    async getAddListen(xmInfo) {
      const { code, msg, data } = await xuanMiCall.addListen({ extensionNumber: this.extno, xmInfo })
      if (code === RESPONSE_CODE.SUCCESS) {
        // 接听成功之后调接听量查询接口
        this.getQueryListen()
        return
      } else {
        this.$message.error(msg)
      }
    },
    // 接听量
    async getQueryListen() {
      const { code, msg, data } = await xuanMiCall.queryListen({ extensionNumber: this.extno })
      if (code === RESPONSE_CODE.SUCCESS) {
        this.answernum = data
        return
      } else {
        this.$message.error(msg)
      }
    },
    bind_event(opcall) {
      let that = this
      // 登录
      opcall.lib
        .event('login')
        .unsubscribe()
        .subscribe(function () {
          console.log('登录成功');
          that.$nextTick(() => {
            that.softPhoneStatus = 2
          })

        })
      // 登出
      opcall.lib
        .event('logout')
        .unsubscribe()
        .subscribe(function () {
          that.softPhoneStatus = 1
          console.log('登出了===============');
        })
      // 登录失败
      opcall.lib.event('login_fail').subscribe(function (data) {
        that.softPhoneStatus = 1
        that.error(`登陆失败：${data.message}`)
      })
      // 排队数量
      opcall.lib
        .event('member_count')
        .unsubscribe()
        .subscribe(function (count) {
          that.waitnum = count
        })
      // 签入之后
      opcall.lib
        .event('available')
        .unsubscribe()
        .subscribe(function (ext) {
          console.log('坐席签入、收到坐席置闲信令：')
          console.log(ext)
          that.softPhoneStatus = 4
        })
      // 签出
      opcall.lib
        .event('unavailable')
        .unsubscribe()
        .subscribe(function (ext) {
          console.log('收到坐席置忙信令：')
          console.log(ext)
          if (ext.state_cause === 'pause') {
            console.log('处理中');
            that.softPhoneStatus = 8
            return
          } else {
            that.softPhoneStatus = 3
          }
        })
      // 当分机拨打或者接到来电，并且振铃时，释放此事件
      opcall.lib.event('ring').subscribe(function (ext) {
        console.log('当分机拨打或者接到来电，并且振铃时，释放此事件ring')
        console.log(ext);
        that.softPhoneStatus = 5
        that.flag = true
      })
      // 当分机拨打或者接到来电，并且接通时，释放此事件
      opcall.lib.event('busy').subscribe(function (ext) {
        // that.success(`电话接通了`)
        // order_no => 订单号码
        // peer => 手机号
        console.log('当分机拨打或者接到来电，并且接通时，释放此事件--busy')
        console.log(ext)
        that.softPhoneStatus = 6
        if (that.flag) {
          that.trackingnumber = ext.order_no
          that.phone = ext.peer
          that.currenPhone = ext.peer
          that.uuid = ext.cdr_uuid ? ext.cdr_uuid : ext.uuid
          that.uuidObj = {uuid: that.uuid, phone:that.phone};
          localStorage.setItem('uuidObj', JSON.stringify(that.uuidObj));
          that.getAddListen(JSON.stringify(ext))
          that.flag = false
        }
      })
      /**
      * 处理坐席保持事件
      */
      opcall.lib
        .event('hold')
        .unsubscribe()
        .subscribe(function (ext) {
          console.log('收到坐席保持信令：')
          console.log(ext)
          that.softPhoneStatus = 7
        })
      // 当分机注册在线，并且从其他状态转为空闲状态时，释放此事件
      opcall.lib.event('idle').subscribe(function (ext) {
        console.log('当分机注册在线，并且从其他状态转为空闲状态时，释放此事件idle')
        console.log(ext);
        that.softPhoneStatus = 4
      })
      //  当话机物理掉线时，释放此事件
      opcall.lib.event('offline').subscribe(function (ext) {
        // that.softPhoneStatus = 1
        console.log('当话机物理掉线时，释放此事件')
        console.log(ext);
        that.warning(`收到话机离线信令`)
        that.login('登出')
      })
      //被强制退出
      opcall.lib.event("force_logout").unsubscribe().subscribe(function (ext) {
        console.log('坐席被强制退出了');
        console.log(ext);
        that.warning(`坐席被强制退出了`)
        // that.login('登出')
      });

      // 当调用服务器超时时，触发此事件
      opcall.lib
        .event('call_timeout')
        .unsubscribe()
        .subscribe(function (ext) {
          that.error("本次调用超时：重复登录或服务器连接断开");
        })
      opcall.lib.event("wsclose").unsubscribe().subscribe(function () {
        console.log('WebSocket关闭了');
        // that.warning(`WebSocket关闭了`)
      });
      // wserror WebSocket 意外错误事件
      opcall.lib.event("wserror").unsubscribe().subscribe(function () {
        // that.warning(`WebSocket发生意外错误事件`)
        console.log('wserror意外错误事件');
      });;

    },
    setready() {
      // 保存录单页面后，调用此方法，电话条重新就绪
      if (this.softPhoneStatus === 8) {
        this.softPhoneStatus = 4
      }
    },
    // 登录 登出
    async login(text) {
      let that = this
      this.loadingLogin = true
      const timer = setTimeout(() => {
        this.loadingLogin = false
      }, TIMEOUT)
      if (text == '登陆') {
        try {
          const { data } = await xuanMiCall.getToken({})
          const cti_config = {
            disable_system_alert: true,
            debug: true,
            baseurl: data.url,
            user: data.userCode,
            sso_token: data.token,
            login_queue: data.queue,
            login_ext_no: this.extno,
            websocket_address: data.websocketAddress,
          }
          console.log(cti_config);
          that.opcall = new call(cti_config)
          that.bind_event(this.opcall)
          that.getQueryListen()
          clearTimeout(timer)
          that.loadingLogin = false
          that.opcall.lib.startup()
        } catch (err) {
          console.log(err)
          clearTimeout(timer)
          that.loadingLogin = false
        }
      } else if (text == '登出') {
        that.opcall.lib.stop()
        clearTimeout(timer)
        that.loadingLogin = false

      }
    },
    // 未就绪 就绪
    ready(text) {
      let that = this
      this.loadingReady = true
      const timer = setTimeout(() => {
        this.loadingReady = false
      }, TIMEOUT)
      if (text === '未就绪') {
        that.opcall.cli.adv_agent_status(that.extno, 'ready', '', function (data) {
          clearTimeout(timer)
          that.loadingReady = false
        })
      } else if (text === '就绪') {
        that.opcall.cli.adv_agent_status(that.extno, 'break1', '', function (data) {
          clearTimeout(timer)
          that.loadingReady = false
        })
      }
    },
    // 保持 取消保持
    hold(text) {
      /**
       * 参数1：表示要保持的分机号，-表示当前登录的分机号
       * 参数2：是否要确认保持的提示文字，null表示不确认
       * 参数3：保持完成后的回调函数，在回调函数中，会回调一个data的Json对象，用于表示是否成功，
       *        他包含了以下属性：
       *			success:  是否成功，true表示成功，false表示失败，
       *			message： 失败原因
       */
      let that = this
      this.loadingHold = true
      const timer = setTimeout(() => {
        this.loadingHold = false
      }, TIMEOUT)
      if (text === '保持') {
        that.opcall.cli.hold(that.extno, null, function (data) {
          clearTimeout(timer)
          that.loadingHold = false
        })
      } else {
        // 取消保持
        that.opcall.cli.unhold(that.extno, null, function (data) {
          clearTimeout(timer)
          that.loadingHold = false
        })
      }
    },
    // 邀评
    survey() {
      let that = this
      this.loadingSurvey = true
      const timer = setTimeout(() => {
        this.loadingSurvey = false
      }, TIMEOUT)
      that.opcall.cli.feedback(that.extno, '', function (data) {
        clearTimeout(timer)
        that.loadingSurvey = false;
      });
    },
    // 挂断
    hangup() {
      let that = this
      this.loadingHungup = true
      const timer = setTimeout(() => {
        this.loadingHungup = false
      }, TIMEOUT)
      that.opcall.cli.hangup(that.extno, null, function (data) {
        that.$emit('talkEnd')
        // that.phone = ''
        // that.currenPhone = ''
        clearTimeout(timer)
        that.loadingHungup = false
      })
    },
  },
}
</script>
<style lang="scss">
.misoftphone {
  width: 100%;
  height: 70px;
  margin-bottom: 10px;
  @include base-color('bg');
  border-radius: 0px;
  border: 1px solid rgba(221, 221, 221, 1);
  @include border-color('brand');
  .el-button.el-button--primary.is-disabled {
    background-color: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.3);
    span {
      color: #fff !important;
    }
  }
  .el-button.el-button--primary {
    background-color: #fff;
    border-color: #fff;
    border: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    span {
      @include base-color('clr');
    }
    &:focus,
    &:link,
    &:active,
    &:visited {
      background-color: #fff;
      border-color: #fff;
    }
    &:hover {
      background-color: rgba(255, 255, 255, 0.6);
      border-color: rgba(255, 255, 255, 0.6);
    }
  }
  .el-icon-loading {
    color: #f5901f;
  }
  .phonestatus {
    margin: 10px 0;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    .light {
      border-radius: 50%;
      width: 11px;
      background-color: red;
      height: 11px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
